module.exports = __webpack_public_path__ + "img/minimize_focused_pressed.b0e114fb.png";